import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { Form,  Button, Message} from 'semantic-ui-react'
import _ from 'lodash';
import TitDer from '../../../components/funcionales/titder';

import jsPDF from 'jspdf';
import 'jspdf-autotable';

// import SeguroPermite from '../../../components/funcionales/seguropermite'
import EstaSeg7Btn from '../../../components/funcionales/estaseg7btn';

import XLSX from 'xlsx'
import { saveAs } from 'file-saver';

//utils
import queries from '../../../utils/queries'
var moment = require('moment');

const DetallePl = ({elemento, handleClickidLista}) => {
  let colorCelda='white', colorNoEjec='white'
  if(elemento.alimSistema && elemento.alimSistema==='S'){
    colorCelda = 'green'
    colorNoEjec='green'
    if(elemento.realizado==='N'){
      colorNoEjec='red'
    }
  }
  return(
    <tr className=''  onClick={(ev)=>handleClickidLista(ev, elemento)}>
      <td className='' style={{color: 'black', background: colorNoEjec, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.ruta}</td>
      <td className='' style={{color: 'black', background: colorNoEjec, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.numeroOrden}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaProg.substr(0, 10)}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.realizado==='S'?elemento.fechaReal.substr(0, 10):''}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEmpresa}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.nombreUsuarioReal?elemento.nombreUsuarioReal:''}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrPlanta}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrSeccion}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrEquipo}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrComponente}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMecanismo}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrMetodo}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrTarea}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.descrFrecuencia}</td>
      <td className='' style={{color: 'black', background: colorCelda, paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12}}>{elemento.fechaUlt?elemento.fechaUlt.substr(0, 10):''}</td>
    </tr>
  )
};

const ListaPl = ({list, handleClickidLista}) => {
  const nivel1Detalle = list.map((elemento, i) => <DetallePl elemento={elemento} handleClickidLista={handleClickidLista} key={i}/>);
  return(
    <tbody className=''>
      {nivel1Detalle}
    </tbody>
  )
};

// const DetallePlDet = ({elemento, handleClickidLista, idLista}) => {
//   let urlSlcm = 'https://montserratslcm.com/api/imgorden/' 
//   let colorCelda='white'
//   if(elemento.alimSistema && elemento.alimSistema==='S'){
//     colorCelda = 'green'
//   }
//   return(
//     <tr className='' onClick={(ev)=>handleClickidLista(ev, elemento)}>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.numeroOrden}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.descrFrecuencia}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.descrLubricante}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.realizado}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.numeroInflab}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.mecInflab}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.fechaReal?elemento.fechaReal.substr(0, 10):''}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.horaReal?elemento.horaReal:0}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.minutosReal}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.cantidadReal}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.abrevUnidad}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.acumReal}</td>
//       <td className='' style={{paddingTop: '0.2em', paddingBottom: '0.2em', fontSize: 12,
//               color: 'black', background: colorCelda}}>{elemento.observacionesReal}</td>

//     </tr>

//   )
// };

// const ListaPlDet = ({list, handleClickidLista, idLista}) => {
//   const nivel1Detalle = list.map((elemento, i) => <DetallePlDet elemento={elemento} handleClickidLista={handleClickidLista} 
//   key={i} idLista={idLista}/>);
//   return(
//     <tbody className=''>
//       {nivel1Detalle}
//     </tbody>
//   )
// };

class ProgRepProgInd2 extends React.Component {
  state={list: this.props.list, argsBuscProg: {}, errors: [], idLista: {} 
    }

  handleClickidLista = async (ev, idLista)=>{
    console.log(idLista)
    ev.preventDefault()
      this.setState({idLista: idLista})
  }

  async componentDidUpdate(prevProps){
    if(this.props.argsBuscProg!==this.state.argsBuscProg){
      let list = []
      let argsBuscar="'estadoOrden': 'Abierto'"
      if(this.props.argsBuscProg.ruta){
        argsBuscar += `, 'ruta': ${this.props.argsBuscProg.ruta}`
      }
      if(this.props.argsBuscProg.descrEmpresa && this.props.argsBuscProg.descrEmpresa!=='Seleccionar Empresa...'){
        argsBuscar += `, 'descrEmpresa': /${this.props.argsBuscProg.descrEmpresa}/i`
      }
      if(this.props.argsBuscProg.descrPlanta){
        argsBuscar += `, 'descrPlanta': /${this.props.argsBuscProg.descrPlanta}/i`
      }
      if(this.props.argsBuscProg.descrSeccion){
        argsBuscar += `, 'descrSeccion': /${this.props.argsBuscProg.descrSeccion}/i`
      }
      if(this.props.argsBuscProg.descrEquipo){
        argsBuscar += `, 'descrEquipo': /${this.props.argsBuscProg.descrEquipo}/i`
      }
      if(this.props.argsBuscProg.alimSistema && (this.props.argsBuscProg.alimSistema==='Pendiente' || this.props.argsBuscProg.alimSistema==='pendiente')){
        argsBuscar += `, 'alimSistema': 'N'`
      }

      let argsBuscarOrden = {tipoqry: `[{$match: {${argsBuscar}}}, {$sort: {descrEmpresa: 1, ruta: 1, numeroOrden: 1}}]`}
      await this.props.allOrdenRtes2.refetch(argsBuscarOrden)
      if(this.props.allOrdenRtes2.allOrdenRtes){
        this.setState({argsBuscProg: this.props.argsBuscProg})
        if(this.props.allOrdenRtes2.allOrdenRtes&&prevProps.allOrdenRtes2.allOrdenRtes){
          if((this.props.allOrdenRtes2.allOrdenRtes!==prevProps.allOrdenRtes2.allOrdenRtes)||!this.state.list){
            this.setState({list: this.props.allOrdenRtes2.allOrdenRtes})
          }
        }
        this.setState({argsBuscProg: this.props.argsBuscProg})
      }
    }
  }

  render(){
    const {errors, list, idLista} = this.state;

    let lista=list
    let descrEmpresaUA=localStorage.getItem('Empresa')
    if(descrEmpresaUA!=="Todas..."){
      if(lista){
        lista = lista.filter(elemento => elemento.descrEmpresa===descrEmpresaUA)
      }
    }

    return (
        <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
          <TitDer list={lista} textBoton1="Rutas programadas y abiertas" btnNuevo={"NO"} styles={this.props.styles}  />
          <Form name="form1" id="form1"> 
            <div>
              <div style={{height: '56em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>ruta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '6%'}}>Orden</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Fecha prog.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Fecha ejec.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Empresa</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Operario ejec.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Planta</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Sección</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '14%'}}>Equipo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '14%'}}>Componente</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '14%'}}>Mecanismo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Metodo</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '11%'}}>Tarea</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Frecuencia</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em', width: '8%'}}>Ult. ejec</th>
                    </tr>
                  </thead>
                  <ListaPl list={lista} handleClickidLista={this.props.handleClickidLista}/>
                </table>
                <p></p>
              </div>
            </div>
            <hr></hr>
            <div>
              <div style={{height: '28em', overflow: 'auto'}}>
                <table id="tabla" className='ui blue inverted celled selectable table' style={this.props.styles.styTableSup}>
                  <thead className=''>
                    {/* <tr className=''>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Orden</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>tipo frec.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Lubricante</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Realizado?</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Rep. lab.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Inf. lab.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Fecha real</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Hora real</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Min. real</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Cant. real</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Und.</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Acum. (horas/km)</th>
                      <th className='' style={{color: 'black', background: '#FE0000', paddingTop: '0.4em', paddingBottom: '0.4em'}}>Observaciones</th>                    
                    </tr>  */}
                  </thead>
                  {/* <ListaPlDet list={list} handleClickidLista={this.handleClickidLista} idLista={idLista}/> */}
                </table>
                <p></p>
              </div>
            </div>
            <hr></hr>
            
            <div className="ui two column stackable grid">
              <div className="row container">
                <div className="column" style={{width: '50%', paddingTop: '0.3em'}}>
                  <div>
                    <img src={idLista.imgAntes?'https://montserratslcm.com/api/imgorden/' + idLista.imgAntes:""} width='70%'></img>
                  </div>
                </div>
                <div className="column" style={{width: '50%', paddingTop: '0.3em'}}>
                  <div>
                    <img src={idLista.imgDespues?'https://montserratslcm.com/api/imgorden/' + idLista.imgDespues:""} width='70%'></img>
                  </div>
                </div>
              </div>
            </div>

            {
              errors.length?<Message negative header="Los siguientes errores:"
              list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
            }

          </Form>
        </div>
    )
  }
};

export default compose(
  graphql(queries.query.allOrdenRtes, {name:'allOrdenRtes2',
    options: (props) => {return {variables: {tipoqry: `[{$match: {'ruta': -1}}]`}}}}),
)(ProgRepProgInd2)
